import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/groups/")({
  head: () => ({
    meta: [{ title: "小组管理 · imiker CRM" }],
  })
});
